<script>
import Multiselect from "vue-multiselect";
import profileForm from "@/components/app/profile/profileInfoForms/mixin/profileForm";
import {minLength, sameAs} from "vuelidate/lib/validators";
import {userMixin} from "@/mixin";

export default {
    name: "AddressForm",
    components: {Multiselect},
    mixins: [userMixin, profileForm],
    validations: {
        user: {
            city: {minLength: minLength(2)},
            street: {minLength: minLength(2)},
            house: {minLength: minLength(1)},
        }
    },
}
</script>

<template>
    <div class="user-section">
        <div class="row">
            <div class="col-12 user-section-header">
                <h3>Адреса:</h3>
                <hr/>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Місто</div>
                    <multiselect
                        v-if="!skeletonOff"
                        :class="['form-control', 'choice_city']"
                        v-model="user.city"
                        :options="citiesList"
                        placeholder="Виберіть місто"
                        @search-change="searchCities"
                        :internal-search="false"
                        label="name_full_name_ua"
                        :allow-empty="false"
                        track-by="name">
                        <template v-slot:noOptions>
                            Почніть вводити назву міста
                        </template>
                        <template slot="noResult">
                            Результатів немає
                        </template>
                    </multiselect>
                    <PuSkeleton class="skeleton-input" v-else/>

                    <small class="error" v-if="$v.user.city.$dirty && !$v.user.city.minLength">Введіть коректний місто</small>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Вулиця</div>
                    <input v-if="!skeletonOff" v-model.trim="user.street" type="text" placeholder="Вулиця"
                           :class="['form-control', {invalid: ($v.user.street.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>

                    <small class="error" v-if="$v.user.street.$dirty && !$v.user.street.minLength">Введіть коректну вулицю</small>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <div class="field-label">Будинок</div>
                    <input v-if="!skeletonOff" v-model.trim="user.house" type="text" placeholder="Будинок"
                           :class="['form-control', {invalid: ($v.user.house.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>

                    <small class="error" v-if="$v.user.house.$dirty && !$v.user.house.minLength">Введіть коректну адресу</small>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <div class="field-label">Квартира</div>
                    <input v-if="!skeletonOff" v-model.trim="user.apartment" type="text"
                           placeholder="Квартира" :class="['form-control']">
                    <PuSkeleton class="skeleton-input" v-else/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
